import React from 'react';
import { WATERMARK_NAME } from '../constants';

const Watermark = ({
  text = "DEMO",
  horizontalOffset = 0,
  verticalOffset = 0,
}) => {
  // Check for the environment variable directly
  if (process.env.REACT_APP_SHOW_WATERMARK === 'false') {
    return null; // Don't render if 'false'
  }
  text = WATERMARK_NAME;
  return (
    <div
      style={{
        position: 'fixed',
        top: `calc(50% + ${verticalOffset}px)`,
        left: `calc(50% + ${horizontalOffset}px)`,
        transform: 'translate(-50%, -50%) rotate(-30deg)',
        fontSize: '5rem',
        color: 'rgba(0, 0, 0, 0.1)',
        zIndex: 9999,
        pointerEvents: 'none',
        userSelect: 'none',
        whiteSpace: 'nowrap',
      }}
    >
      {text}
    </div>
  );
};

export default Watermark;